import { Fragment, useMemo, useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { useMaskPII } from 'hooks/useMaskPII';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { NsCard } from 'components/common/ns-card/NsCard';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'addressInfoTestId';

export const AddressInfo = () => {
  const { postcode, displayName } =
    useSelector(selectedAddress, shallowEqual) || {};
  const { mask } = useMaskPII();
  const { next, eventTypes } = useNavigation();

  const handleGoBack = useCallback(() => {
    next({ eventType: eventTypes.CHANGE_ADDRESS, wasVisited: true });
  }, [eventTypes, next]);

  return useMemo(
    () => (
      <div data-testid={testId}>
        <NsCard
          type="support"
          heading="Your address"
          action={
            <NsSecondaryCta onClick={handleGoBack}>
              Change your address
            </NsSecondaryCta>
          }
        >
          {
            <>
              {displayName &&
                displayName.split(',').map((f, index) => (
                  <Fragment key={index}>
                    <span {...mask}>{f}</span>
                    <br />
                  </Fragment>
                ))}
              <p {...mask}>{postcode}</p>
            </>
          }
        </NsCard>
      </div>
    ),
    [displayName, postcode, handleGoBack, mask]
  );
};
